import {
  Component,
  OnInit,
  HostBinding,
  Input,
  ElementRef,
} from '@angular/core';
import { LoadIndicatorService } from '../../core/load-indicator.service';

@Component({
  selector: 'hr-load-mask',
  templateUrl: './load-mask.component.html',
  styleUrls: ['./load-mask.component.css'],
  standalone: false,
})
export class LoadMaskComponent implements OnInit {
  constructor(
    private loadIndicator: LoadIndicatorService,
    private elementRef: ElementRef
  ) {}

  @Input('target')
  public targetId: string = 'global';

  //@HostBinding('class.loading-mask')
  public get isLoading() {
    return this.loadIndicator.isLoading(this.targetId);
  }

  ngOnInit() {
    //if (this.targetId == 'global' && this.elementRef.nativeElement != document.body) {//TODO find better solution wihtoud direct dom manipulation
    //    console.log('error: non global load mask must have targetId');
    //}
  }
}
